import * as React from "react";
import PropTypes, { element } from "prop-types";

import { Box, Button, Paper, Stack } from "@mui/material";
import {
  DataGrid,
  GridToolbarDensitySelector,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import PlaylistAddRoundedIcon from "@mui/icons-material/PlaylistAddRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import { Grid } from "@mui/material";

import DataGridcsar from "../../Components/CSAR";
import Incometype from "../../Components/Incometype";
import DraggableDialog from "../../../Components/CustomDialogs/DraggableDialog";

import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

const styleMenu = {
  color: "black",
  cursor: "pointer",
  fontFamily: "Customfont !important",
  borderColor: "#bcbcbc",
  backgroundColor: "#bcbcbc",
};

export default function Withholding(props) {
  const { defaultdata, payforservice, userData } = props;
  const [rows, setRows] = React.useState([]);
  //----------------------------alert ----------------------------
  const [title, setTitle] = React.useState("");
  const [buttontxt, setButtontxt] = React.useState("");
  const [openModle, setOpenModle] = React.useState(false);
  const [typeModle, setTypeModle] = React.useState(false);
  const [clickrowsID, setClickrowsID] = React.useState("");
  const [defaultinputValue, setDefaultinputValue] = React.useState("0");
  const [selectionModel, setSelectionModel] = React.useState([]);

  let idCounter = 0;
  const createRow = (data, empty) => {
    // ถ้ามีข้อมูลใน rows staet
    if (rows.length > 0) {
      const ids = rows.map((object) => {
        return object.id;
      });
      const max = Math.max(...ids);
      idCounter = max;
    }
    idCounter += 1;
    let lastdata;
    if (empty === true) {
      let newdata = data.reduce(
        (a, v) => ({ ...a, [v]: v.search(/date/) > -1 ? new Date() : "" }),
        {}
      );
      lastdata = { ...newdata, id: idCounter };
    }
    //  console.log(lastdata);
    return lastdata;
  };

  const columns = [
    { field: "id", headerName: "ID", width: 40 },
    {
      field: "no",
      headerName: "เลขที่",
      width: 200,
      editable: true,
      maxwidth: 200,
    },
    {
      field: "incometype",
      headerName: "ประเภทเงินได้",
      width: 200,
      editable: true,
      maxwidth: 200,
      editable: false,
      sortable: false,
    },
    {
      field: "incometypecode",
      headerName: "ประเภทเงินได้(incometypecode)",
      width: 100,
      editable: true,
      maxwidth: 100,
      editable: false,
      sortable: false,
      hide: true,
    },
    {
      field: "incometypeaction",
      headerName: "",
      sortable: false,
      width: 34,
      renderCell: (params) => {
        const onClick = () => {
          setTypeModle("incometypeaction");
          setClickrowsID(params.id);
          setOpenModle(true);
        };
        return (
          <SearchRoundedIcon onClick={onClick} sx={{ cursor: "pointer" }}>
            Click
          </SearchRoundedIcon>
        );
      },
    },
    {
      field: "createdate",
      headerName: "ลงวันที่",
      type: "date",
      width: 110,
      editable: true,
    },
    {
      field: "arcode",
      headerName: "รหัสลูกหนี้",
      width: 200,
      editable: true,
      // type: 'singleSelect',
      //  valueOptions: ardata,
      maxwidth: 200,
      editable: false,
      sortable: false,
      // hidden: true
    },
    {
      field: "araction",
      headerName: "",
      sortable: false,
      width: 34,
      renderCell: (params) => {
        //     console.log("params", params)
        const onClick = () => {
          setTypeModle("araction");
          setClickrowsID(params.id);
          setOpenModle(true);
        };
        return (
          <SearchRoundedIcon onClick={onClick} sx={{ cursor: "pointer" }}>
            Click
          </SearchRoundedIcon>
        );
      },
    },
    {
      field: "arname",
      headerName: "ชื่อผู้ขาย/ผู้ให้บริการ",
      width: 200,
      editable: false,
    },
    {
      field: "remark",
      headerName: "หมายเหตุ",
      width: 200,
      editable: true,
    },
    {
      field: "rate",
      headerName: "อัตรา",
      width: 90,
      editable: false,
    },
    {
      field: "beforetax",
      headerName: "ยอดก่อนภาษี",
      width: 150,
      editable: true,
    },
    {
      field: "tax",
      headerName: "ภาษี",
      width: 150,
      editable: false,
    },
  ];

  const Dataselect = async (e) => {
    setOpenModle(false);
    // console.log("Dataselect clickrowsID", clickrowsID)
    // console.log("Dataselect", e)
    // console.log("Dataselect  rows[clickrowsID]", rows)
    const newState = rows.map((obj) => {
      // 👇️ if id equals 2, update country property
      if (obj.id === clickrowsID) {
        if (typeModle === "araction") {
          return { ...obj, arcode: e[0].code, arname: e[0].arname };
        } else {
          return {
            ...obj,
            incometypecode: e[0].code,
            incometype: e[0].nameTH,
            rate: e[0].rate,
          };
        }
      }
      // 👇️ otherwise return object as is
      return obj;
    });
    console.log("Dataselect newState", newState);
    await setRows(newState);

    // setArdata(e)
  };
  React.useEffect(() => {
    let newrows = 10;
    console.log("useEffect rows.length ", rows.length);
    if (rows.length <= 0) {
      let field = [];
      columns.forEach((element) => {
        if (element.field != "id") {
          field.push(element.field);
        }
      });
      for (let index = 0; index < newrows; index++) {
        setRows((prevRows) => [...prevRows, createRow(field, true)]);
      }
    }
    return () => {};
  }, [columns]);
  React.useEffect(async () => {
    console.log("useEffectrows payforservice", payforservice);
    await setrowsData();
    return () => {};
  }, [payforservice]);

  React.useEffect(() => {
    console.log("useEffectrows", payforservice);

    sumtax();
    return () => {};
  }, [rows]);
  const setrowsData = async () => {
    let elements = [];
    payforservice.forEach((element) => {
      // console.log("element", element)
      elements.push({
        araction: "",
        arcode: "",
        arname: "",
        beforetax: element.PAYAMOUNT,
        createdate: new Date(),
        id: element.id,
        incometype: element.INCOMETYPENAME,
        incometypeaction: "",
        incometypecode: element.INCOMETYPE,
        no: ".",
        rate: element.WTAXRATE,
        remark: element.PRODUCTNAME,
        tax: element.WTAXAMOUNT,
      });
    });
    await setRows(elements);
  };

  const sumtax = async () => {
    let sumtax = 0;
    rows.forEach((element) => {
      sumtax = sumtax + Number(element.tax);
    });
    props.rswithholding(rows);
    props.sumtaxwithholding(sumtax);
  };

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <Stack direction="row" spacing={2}>
          <Button
            variant="outlined"
            startIcon={<PlaylistAddRoundedIcon />}
            size="small"
            onClick={handleAddRow}
            sx={styleMenu}
          >
            เพิ่มแถว
          </Button>
          <Button
            variant="outlined"
            startIcon={<DeleteOutlineRoundedIcon />}
            onClick={(e) => delData()}
            size="small"
            style={{ display: selectionModel.length > 0 ? "inherit" : "none" }}
            sx={styleMenu}
          >
            ลบแถว
          </Button>
          <Button
            variant="outlined"
            startIcon={<CheckCircleOutlineRoundedIcon />}
            size="small"
            // onClick={e => selectData()}
            style={{ display: selectionModel.length > 0 ? "inherit" : "none" }}
            sx={styleMenu}
          >
            ตกลง
          </Button>
          <GridToolbarDensitySelector sx={styleMenu} />
        </Stack>
      </GridToolbarContainer>
    );
  };
  const delData = async () => {
    const selectedIDs = new Set(selectionModel);
    // you can call an API to delete the selected IDs
    // and get the latest results after the deletion
    // then call setRows() to update the data locally here
    await setRows((r) => r.filter((x) => !selectedIDs.has(x.id)));
  };
  // เพิ่มแถวในตาราง
  const handleAddRow = () => {
    let field = [];
    columns.forEach((element) => {
      if (element.field != "id") {
        field.push(element.field);
      }
    });
    setRows((prevRows) => [...prevRows, createRow(field, true)]);
    // setTimeout(() => {
    //     console.log("handleAddRow", rows)
    // }, 300);
  };
  const processRowUpdate = async (newRow) => {
    console.log("DataGrid processRowUpdate", newRow);
    let newRowData = [];
    for (let index = 0; index < rows.length; index++) {
      if (newRow.id === rows[index].id) {
        if (Number(newRow.beforetax) > 0 && Number(newRow.rate) > 0) {
          let x = Number(newRow.beforetax) * (Number(newRow.rate) / 100);
          newRowData.push({
            araction: "",
            arcode: newRow.arcode,
            arname: newRow.arname,
            beforetax: newRow.beforetax,
            createdate: newRow.createdate,
            id: newRow.id,
            incometype: newRow.incometype,
            incometypeaction: newRow.incometypeaction,
            incometypecode: newRow.incometypecode,
            no: newRow.no,
            rate: newRow.rate,
            remark: newRow.remark,
            tax: x,
          });
          // setDefaultinputValue(Number(defaultinputValue) + x);
        } else {
          newRowData.push(newRow);
        }
      } else {
        newRowData.push(rows[index]);
      }
    }
    await setRows(newRowData);
    return newRow;
  };

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} lg={12}>
            {rows.length > 0 ? (
              <div style={{ height: 400, width: "100%" }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  editMode="row"
                  rowHeight={38}
                  processRowUpdate={processRowUpdate}
                  checkboxSelection
                  disableSelectionOnClick
                  onSelectionModelChange={(newSelectionModel) => {
                    setSelectionModel(newSelectionModel);
                  }}
                  selectionModel={selectionModel}
                  onRowEditCommit={console.log("DataGrid onRowEditCommit")}
                  experimentalFeatures={{ newEditingApi: true }}
                  components={{
                    Toolbar: CustomToolbar,
                  }}
                />
              </div>
            ) : (
              "กำลังโหลด"
            )}
          </Grid>
        </Grid>

        <DraggableDialog
          open={openModle}
          title={title}
          buttontxt={buttontxt}
          closedialog={(_) => setOpenModle(false)}
        >
          {typeModle === "araction" ? (
            <DataGridcsar Dataselect={(e) => Dataselect(e)} />
          ) : (
            <Incometype Dataselect={(e) => Dataselect(e)} />
          )}
        </DraggableDialog>
      </Box>
    </>
  );
}

Withholding.propTypes = {
  userData: PropTypes.string,
  defaultdata: PropTypes.any,
  payforservice: PropTypes.any,
};
